import { useEffect } from 'react'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { PricingPlans } from '@/components/pricing-plans/PricingPlans.jsx'
import { AnalyticsService } from '@/services/analytics.js'

export const PricingPlansDialog = ({ isOpen, setIsOpen }) =>  {

    useEffect(() => {
        if (isOpen) {
            AnalyticsService.track('pricing-plans-dialog-opened')
        }
    }, [])

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogContent className="flex max-h-[92vh] flex-col overflow-hidden bg-background sm:max-w-[95%]">
                <DialogHeader className="items-center text-center">
                    <DialogTitle className="text-2xl font-semibold tracking-tight">Choose your plan</DialogTitle>
                    <DialogDescription>
                        Upgrade for unlimited access. Change or cancel anytime.
                    </DialogDescription>
                </DialogHeader>
                <div className="min-h-0 flex-1 overflow-y-auto px-1">
                    <PricingPlans
                        onCheckoutOpened={setIsOpen}
                        onSubscriptionCancelled={setIsOpen}
                    />
                </div>
            </DialogContent>
        </Dialog>
    )
}

